import { Reveal } from "@/components/Section";

const HIGHLIGHTS = [
  ["Skin profile", "Tone, sensitivities, goals and preferred SPF."],
  ["Status reminder (concept)", "A proposed visual reminder linked to your application schedule, with a countdown concept."],
  ["Environmental intelligence", "Real-time UV, heat and humidity, plus on-wrist activity and heart rate."],
  ["Trends", "A protection streak and a simple weekly summary."],
];

export function AppShowcase() {
  return (
    <section className="border-t border-zinc-800 bg-[#0a0a0a]" data-testid="home-app-showcase">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.28em] uppercase text-accent block mb-6">Inside the app</span>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tighter leading-[1.05] text-white max-w-3xl">
            See it in your hand.
          </h2>
          <div className="mt-6 inline-flex items-center gap-2.5 border border-accent/40 bg-accent/[0.06] rounded-full px-4 py-2" data-testid="app-showcase-dev-badge">
            <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
            <span className="font-mono text-[11px] tracking-[0.16em] uppercase text-accent">In active development</span>
          </div>
          <p className="font-body text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl mt-5">
            The WearSpray app is in development. We are rigorously testing and building
            it with our app team, refining the design elements as we go, so these
            screens are purely introductory visuals ahead of release.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center mt-14">
          {/* Video */}
          <Reveal>
            <div className="flex justify-center">
              <video
                src="/video/app-scroll.mp4"
                poster="/video/app-scroll-poster.jpg"
                autoPlay
                loop
                muted
                playsInline
                className="w-full max-w-[380px] rounded-2xl"
                data-testid="app-showcase-video"
              />
            </div>
          </Reveal>

          {/* Caption */}
          <Reveal delay={0.1}>
            <div>
              <p className="font-body text-zinc-300 text-lg md:text-xl leading-relaxed max-w-md">
                A quick walk-through of WearSpray, from your skin profile to live protection and weekly trends.
              </p>
              <div className="mt-10 space-y-6 border-l border-zinc-800 pl-6">
                {HIGHLIGHTS.map(([t, d]) => (
                  <div key={t} data-testid={`app-showcase-highlight-${t.toLowerCase().replace(/\s+/g, "-")}`}>
                    <h3 className="font-heading text-lg font-medium text-white">{t}</h3>
                    <p className="font-body text-zinc-400 text-sm leading-relaxed mt-1">{d}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
